import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// Components
import Navbar from './components/Navbar'
import Footer from './components/Footer'

// Pages
import Home from './pages/Home'
import Cars from './pages/Cars'
import CarDetail from './pages/CarDetail'
import Financing from './pages/Financing'
import Ydelse from './pages/Ydelse'
import Referencer from './pages/Referencer'
import ReferenceDetail from './pages/ReferenceDetail'
import Kontakt from './pages/Kontakt'
import Forbidden from './pages/Forbidden'
import NotFound from './pages/NotFound'

// Scroll Restoration Helper
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    document.body.style.overflow = ''
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Instant scroll on route change
    })
  }, [pathname])

  return null
}

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="relative min-h-screen flex flex-col bg-[#0a0b0d] text-slate-100 antialiased selection:bg-[#DFB587] selection:text-black">
        {/* Subtle background glow */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(223,181,135,0.03),transparent_50%)]" />
        
        {/* Navigation */}
        <Navbar />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/biler-til-salg" element={<Cars />} />
            <Route path="/biler-til-salg/:slug" element={<CarDetail />} />
            <Route path="/finansiering" element={<Financing />} />
            <Route path="/ydelse" element={<Ydelse />} />
            <Route path="/referencer" element={<Referencer />} />
            <Route path="/reference" element={<ReferenceDetail />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  )
}

export default App
